import React from 'react'
import styled from 'styled-components'
import { styleTheme } from '../../../../style/theme'

import { FairEventItem } from '../FairEventItem'

import type { BridalFairDate } from '../../BridalFairs.types'

type Props = {
  bridalFairDate: BridalFairDate
  isHoliday: boolean
  bridalFairPageKey: string
}

export const FairEventListOnDate: React.FC<Props> = (props) => <StyledComponent {...props} />

const Component: React.FC<Props & { className?: string }> = ({ className, bridalFairDate, bridalFairPageKey }) => {
  return (
    <div className={className}>
      {bridalFairDate.fairEvents.length > 0 ? (
        <div className="events-wrapper">
          {bridalFairDate.fairEvents.map((fairEvent, index) => {
            return (
              <div key={`fairEvent.${fairEvent.bridalFairDetailKey}.${index}`}>
                <FairEventItem
                  key={`fairEvent.${fairEvent.bridalFairDetailKey}.${index}`}
                  fairEvent={fairEvent}
                  fairDate={bridalFairDate.date}
                  bridalFairPageKey={bridalFairPageKey}
                />
              </div>
            )
          })}
        </div>
      ) : (
        <div className="empty-events-wrapper">条件に合ったフェアの開催はありません</div>
      )}
    </div>
  )
}

const StyledComponent = styled(Component)`
  color: ${styleTheme.colors.black};
  .events-wrapper {
    display: grid;
    gap: 16px;
    overflow: hidden;
    transition: 0.25s ease-in-out;
  }

  .empty-events-wrapper {
    border: 1px solid ${styleTheme.colors.gray.baseLight};
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
  }
`
